export const experienceData = [
    {
        id: 1,
        company: 'RS.Santo Borromeus Bandung',
        jobtitle: 'Perawat',
        startYear: '2010',
        endYear: '2013'
    },
    {
        id: 2,
        company: 'RS.Ngesti Waluyo',
        jobtitle: 'Perawat',
        startYear: '2013',
        endYear: '2014'
    },
    {
        id: 3,
        company: 'RS.Bayukarta',
        jobtitle: 'Perawat',
        startYear: '2016',
        endYear: 'Present'
    },
]